import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc3e4500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = {
  style: {"size":"1.5rem"},
  class: "q-pa-md"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { style: {"size":"1.5rem"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "contact_mail",
                style: {"font-size":"2rem","top":"-3px"},
                color: "#273233"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.contact_form')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.mailDescription')), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: "q-pa-md",
      style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:50%')
    }, [
      _createVNode(_component_q_select, {
        outlined: "",
        "use-input": "",
        modelValue: _ctx.subject,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subject) = $event)),
        options: _ctx.emailSubjectOptions,
        label: _ctx.$t('message.subject'),
        "option-value": "id",
        "option-label": "subject",
        class: "form__input",
        "lazy-rules": "",
        "emit-value": "",
        "map-options": ""
      }, null, 8, ["modelValue", "options", "label"]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.mailDetails')) + ":", 1)
        ])
      ]),
      _hoisted_8,
      _createVNode(_component_q_input, {
        maxlength: "1000",
        type: "textarea",
        counter: "",
        class: "input--desire",
        outlined: "",
        modelValue: _ctx.mailDetails,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mailDetails) = $event)),
        placeholder: _ctx.$t('message.write_something'),
        color: "blue-grey-7",
        rows: "10"
      }, null, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_q_btn, {
        disable: _ctx.mailDetails.length == 0,
        "no-caps": "",
        label: _ctx.$t('message.send_email'),
        onClick: _ctx.onSubmit,
        style: {"float":"right","margin-top":"16px","background-color":"#9b7d32","color":"white"}
      }, null, 8, ["disable", "label", "onClick"])
    ], 4)
  ]))
}